var exports = {
  "kL": "xa15a2ab7--9ee8cc--container",
  "iE": "xa15a2ab7--9ee8cc--wrapper",
  "DD": "xa15a2ab7--9ee8cc--title",
  "Kk": "xa15a2ab7--9ee8cc--icon",
};

module.exports = exports;
